import {title} from "assets/jss/material-kit-react.jsx";
import pollBG from "assets/img/bg.png";
import layer from "assets/img/Layer-2745.png";

const answerPollStyle = theme => ({
  pollSection: {
    paddingTop: 50,
    paddingBottom: 50,
    textAlign: "left",
    position: "relative",
    height: 550,
    marginTop: 0,
    backgroundImage: `url(${pollBG}), url(${layer})`,
    backgroundPosition: "50% 50%, 0px 0px",
    backgroundSize: "contain, 720px",
    backgroundRepeat: "no-repeat, repeat",
  },
  title: {
    ...title,
    marginTop: 30,
    marginBottom: 10,
    letterSpacing: 1,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: 45,
    // lineHeight: 50,
    fontWeight: 400,
    textTransform: "none",
    textAlign: "left",
    color: "#707070",
    [theme.breakpoints.down('xs')]: {
      fontSize: 30,
    },
  },
  pollAnchor: {
    paddingTop: 60,
    marginTop: -60,
  },
  phrase: {
    paddingTop: 5,
    fontSize: 14,
    fontWeight: 300,
    letterSpacing: 1,
    textAlign: "center",
  },
  shadowSection: {
    position: "absolute",
    left: 0,
    top: -50,
    right: 0,
    bottom: 0,
    display: "block",
    maxWidth: 650,
    height: 660,
    marginRight: "auto",
    marginLeft: "auto",
    padding: "56",
    backgroundColor: "#fff",
    boxShadow: "1px 1px 19px 0 rgba(0, 0, 0, .16)",
    scrollBehavior: "smooth",
  },
  pollChoices: {
    position: "static",
    marginTop: 50,
  },
  pollChoiceDiv: {
    display: "flex",
    width:" 100%",
    height: 65,
    marginBottom: 15,
    padding: "18px 18px 18px 28px",
    alignItems: "center",
    border: "1px solid #d7d7d7",
    boxShadow: "1px 1px 7px 0 rgba(0, 0, 0, .15)",
    cursor: "pointer",
  },
  pollChoiceTxt: {
    fontSize: 24,
    fontWeight: 300,
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
    },
  },
  selected: {
    paddingLeft: 18,
    borderLeftWidth: 10,
    borderLeftColor: "#ff3e4b",
  },
  selectedTxt: {
    fontWeight: 700,
  },
  submitVoteBtn: {
    width: "100%",
    marginTop: 25,
    paddingTop: 15,
    paddingBottom: 15,
    borderRadius: 25,
    backgroundColor: "#ff3e4b",
    fontSize: 24,
    letterSpacing: 1,
    fontWeight: 300,
    textAlign: "center",
    textTransform: "capitalize",
    display: "inline-block",
    color: "white",
    border: 0,
    lineHeight: "inherit",
    textDecoration: "none",
    cursor: "pointer",
    "&:hover,&:focus": {
      color: "white",
      // background: "rgba(200, 200, 200, 0.2)"
    },
  },
  btnDisabled: {
    // background: "rgba(200, 200, 200, 0.8)",
    background: "rgba(255, 62, 75, 0.3)",
    cursor: "default",
    pointerEvents: 'none',
  },
  disableLink: {
    pointerEvents: 'none',
  },
  logoContain: {
    alignItems: "center",
  },
  tinyLogo: {
    display: "block",
    width: 150,
    marginTop: 30,
    marginRight: "auto",
    marginLeft: "auto",
  },
});

export default answerPollStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/pollTemplateSections/answerPollStyle.jsx